import { InformationsPreAssurabilite } from "../../models";
import { Question as modelQuestion } from "../../models/question";
import i18n from "../../resources/I18n";
import { DsdColumn } from "../DSD/DsdColumn";
import { DsdGrid } from "../DSD/DsdGrid";
import { DsdRow } from "../DSD/DsdRow";
import InstructionQuestionnaire from "./InstructionQuestionnaire";
import * as TYPE_PARCOURS from "../../constants/typeParcours";
import { CSSTransition, TransitionGroup } from "react-transition-group";
import React from "react";
import "./assure.css";
import Question from "./Question";
import { DsdButton } from "../DSD/DsdButton";

interface IAssureProps {
  parcours: string;
  questions: modelQuestion[];
  handleReponseQuestion?: any;
  informationsPreAssurabilite?: InformationsPreAssurabilite;
  idAssure: string;
  showBtnObtenirReponse: boolean;
  onClickObtenirReponse?: () => void;
}

function Assure(props: Readonly<IAssureProps>) {
  function getNomAssure() {
    const assures = props.informationsPreAssurabilite?.assures;
    const idAssure = props.idAssure;
    const assure = assures?.find((a: any) => a.id === idAssure);
    if (assure) {
      const prenom = (assure.prenom ?? "").toString();
      const nom = (assure.nom ?? "").toString();
      return `${prenom} ${nom}`.trim().toUpperCase();
    }
    return "";
  }

  const mapperQuestions = props?.questions?.map((question) => {
    const localNodeRef = React.createRef<HTMLDivElement>();
    return (
      <CSSTransition nodeRef={localNodeRef} key={question.id} timeout={100} classNames="question-transition-amc">
        <div ref={localNodeRef}>
          <Question question={question} handleReponseQuestion={props.handleReponseQuestion} />
        </div>
      </CSSTransition>
    );
  });

  return (
    <dsd-container horizontal-scroll-items={true} padding="md">
      <DsdGrid>
        <DsdRow>
          <DsdColumn col="12" mdCol="12">
            <h3>
              {i18n.t("amc:questionnaire-titre")} {getNomAssure()}
            </h3>
            {props.parcours === TYPE_PARCOURS.ASSISTE && (
              <div className="instruction-questionnaire" data-testid="instruction-questionnaire">
                <InstructionQuestionnaire />
              </div>
            )}
          </DsdColumn>
          <DsdColumn>
            <TransitionGroup>{mapperQuestions}</TransitionGroup>
          </DsdColumn>
          {props.showBtnObtenirReponse && (
            <DsdColumn>
              <DsdButton
                variant="primary"
                id="btn-obtenir-reponse-amc"
                data-testid="btn-obtenir-reponse-amc"
                onClick={props.onClickObtenirReponse}
              >
                {i18n.t("amc:btn-obtenir-reponse-texte")}
              </DsdButton>
            </DsdColumn>
          )}
        </DsdRow>
      </DsdGrid>
    </dsd-container>
  );
}

export default Assure;
